import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_COMMENTS, GET_COMMENTS_SUCCESS, GET_COMMENTS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getComments({ payload }) {
  const { id } = payload.urlParams;

  console.log('payload', payload);
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/${id}/comments`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMMENTS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMMENTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMMENTS_ERROR, payload: error });
  }
}

export function* watchGetComments() {
  yield takeEvery(GET_COMMENTS, getComments);
}

function* getCommentsSaga() {
  yield all([fork(watchGetComments)]);
}

export default getCommentsSaga;
